import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';
import { ComponentPropsWithRef, forwardRef } from 'react';

export interface RadioProps extends ChakraRadioGroup.ItemProps {
    rootRef?: React.Ref<HTMLDivElement>;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
    const { children, inputProps, rootRef, ...rest } = props;
    return (
        <ChakraRadioGroup.Item ref={rootRef} {...rest}>
            <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />
            <ChakraRadioGroup.ItemIndicator />
            {children && <ChakraRadioGroup.ItemText>{children}</ChakraRadioGroup.ItemText>}
        </ChakraRadioGroup.Item>
    );
});

export const RadioGroup = forwardRef<HTMLDivElement, ComponentPropsWithRef<typeof ChakraRadioGroup.Root> & { deselectable?: boolean }>(
    function ExperimentalRadioGroup(props, ref) {
        const { onValueChange, value, onClick, deselectable, ...rest } = props;
        return (
            <ChakraRadioGroup.Root
                {...rest}
                value={value}
                onValueChange={onValueChange}
                onClick={(e) => {
                    if (deselectable && (e.target as HTMLInputElement).value === value) {
                        onValueChange?.({ value: '' });
                    }
                    onClick?.(e);
                }}
                ref={ref}
            />
        );
    },
);
